<template>
  <v-container>
    <v-breadcrumbs
      :items="[
        {
          text: $t('serviceProviders.title'),
          disabled: true,
        },
      ]"
    />
    <app-error :error="error" v-if="error" />
    <h1>{{ $t("serviceProviders.title") }}</h1>
    <v-divider class="mb-2" />

    <v-card>
      <v-card-title>
        <service-provider-filter v-model="filters"> </service-provider-filter>

        <v-spacer></v-spacer>

        <v-menu
          v-model="fromMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="100px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="_formattedFrom"
              prepend-icon="event"
              readonly
              v-on="on"
              class="shrink"
            ></v-text-field>
          </template>
          <v-date-picker v-model="from" @input="fromMenu = false" scrollable />
        </v-menu>

        <v-menu
          v-model="toMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="_formattedTo"
              prepend-icon="event"
              readonly
              v-on="on"
              class="shrink"
            ></v-text-field>
          </template>
          <v-date-picker v-model="to" @input="toMenu = false" scrollable />
        </v-menu>

        <v-btn @click="download" :loading="loading" fab small>
          <v-icon>download</v-icon>
        </v-btn>
      </v-card-title>
    </v-card>
    <v-data-table
      v-if="serviceProviders"
      :headers="headers"
      :items="serviceProviders"
      :loading="loading"
      :options.sync="options"
      :server-items-length="totalCount"
      fixed-header
      multi-sort
      class="elevation-1"
      :footer-props="{
        itemsPerPageOptions: [5, 10, 15, 25, 50, 100, 250, 500, 1000],
      }"
      @click:row="
        $router.push({
          name: 'serviceproviders/details',
          params: { uid: $event.uid },
        })
      "
    >
      <template v-slot:item.subscription.status="{ item }">
        <span v-if="item.subscription">
          {{ $t("subscriptions.status." + item.subscription.status) }}
        </span>
      </template>
      <template v-slot:item.types="{ item }">
        <ul v-if="item.types">
          <li v-for="type in item.types" :key="type.uid">
            {{ type.name }}
          </li>
        </ul>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import ServiceProviderFilter from "@/components/service_providers/ServiceProviderFilter";

export default {
  data() {
    return {
      serviceProviders: null,
      error: null,
      loading: false,
      totalCount: 0,
      filters: this.getFilters(),
      options: {},
      headers: [
        {
          text: this.$t("serviceProviders.status"),
          value: "subscription.status",
          sortable: false,
        },
        { text: this.$t("serviceProviders.title"), value: "title" },
        { text: this.$t("serviceProviders.visibility"), value: "status" },
        {
          text: this.$t("serviceProviders.customer"),
          value: "customer.username",
          sortable: false,
        },
        {
          text: this.$t("serviceProviders.types"),
          value: "types",
          sortable: false,
        },
      ],
      from: null,
      to: null,
      fromMenu: false,
      toMenu: false,
    };
  },
  watch: {
    options: {
      handler() {
        this.fetchServiceProviders();
      },
      deep: true,
    },
    filters: {
      handler() {
        this.options.page = 1;
        this.storeFilters();
        this.fetchServiceProviders();
      },
      deep: true,
    },
  },
  mounted() {
    this.fetchServiceProviders();
  },
  methods: {
    fetchServiceProviders() {
      this.loading = true;
      this.error = null;

      const { sortBy, sortDesc, page, itemsPerPage } = this.options;

      var order = [];
      if (sortBy) {
        for (let i in sortBy) {
          order.push(sortBy[i] + ":" + (sortDesc[i] ? "desc" : "asc"));
        }
      }

      let params = {
        size: itemsPerPage,
        page: page,
        order: order,
        filters: this.filters,
        includes: ["subscription", "subscription.billing", "customer"],
      };

      this.$store
        .dispatch("serviceProviders/list", params)
        .then((p) => {
          if (p && p.items) {
            this.serviceProviders = p.items;
            this.totalCount = p.count;
          } else {
            this.serviceProviders = [];
          }
        })
        .catch((err) => {
          this.error = err;
          this.serviceProviders = [];
        })
        .finally(() => (this.loading = false));
    },
    download() {
      if (this.loading) return;

      const url = new URL("/api/v1/serviceproviders", document.baseURI);
      if (this.filters) {
        Object.keys(this.filters).forEach((k) => {
          if (Array.isArray(this.filters[k]))
            this.filters[k].forEach((v) => url.searchParams.append(k, v));
          else url.searchParams.append(k, params.filters[k]);
        });
      }

      if (this.from) {
        url.searchParams.append("from", this.from);
      }

      if (this.to) {
        url.searchParams.append("to", this.to);
      }

      this.loading = true;
      this.error = null;
      this.$http
        .get(url.toString(), {
          headers: {
            Accept: "text/csv",
          },
        })
        .then((r) => {
          let blob = new Blob([r.data], { type: r.headers["content-type"] });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = "maximi_serviceproviders.csv";
          link.click();
        })
        .catch((err) => (this.error = err))
        .finally(() => (this.loading = false));
    },
    getFilters() {
      if (window.sessionStorage) {
        let filter = window.sessionStorage.getItem(
          "ServiceProvidersListView.Filter"
        );
        if (filter) {
          return JSON.parse(filter);
        }
      }

      return {
        status: ["ACTIVE"],
        visibility: ["publish"],
      };
    },
    storeFilters() {
      if (window.sessionStorage) {
        window.sessionStorage.setItem(
          "ServiceProvidersListView.Filter",
          JSON.stringify(this.filters)
        );
      }
    },
  },
  components: {
    ServiceProviderFilter,
  },
  computed: {
    _formattedFrom() {
      return this.from ? this.$d(new Date(this.from), "short") : "";
    },
    _formattedTo() {
      return this.to ? this.$d(new Date(this.to), "short") : "";
    },
  },
};
</script>

<style></style>
